<template>
    <div class="flat-row-half">
        <div class="shopping-cart">
            <div class="container">
                <div action="#" class="form-cart">
                    <div v-if="cart && cart.length">
                        <div class="table-responsive d-none d-sm-block">
                        <table class="shop-table mt-2">
                            <thead>
                                <tr>
                                    <th class="edit-product"></th>
                                    <th class="img-product"></th>
                                    <th class="describe-product">Course Description</th>
                                    <th class="total-product">Total Excl. VAT</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="cart-table-body">
                                <tr v-for="item in cart" class="res-mg">
                                    <td class="cart-table-column"></td>
                                    <td class="cart-table-column img-product d-flex flex-column justify-content-center align-items-center" data-title="PRODUCT">
                                        <img v-bind:src="item | s3url" style="width: 100%; height: 100%; margin-top: 35px; max-width: 200px;">
                                    </td>
                                    <td class="cart-table-column describe-product">
                                        <span class="text pl-2"> {{ item.name }}</span>
                                        <span class="text-success" v-if="item.couponCode"> (Coupon: {{ item.couponCode }}, Discount: {{ item.discountPercentage }}%)</span>
                                    </td>


                                    <td v-if="!item.couponCode" class="cart-table-column price-product res-15" data-title="UNIT PRICE">{{ item.priceUsd ? "$" + item.priceUsd : (item.price ? "R" + item.price : "") }}</td>

                                    <td v-if="item.couponCode" class="cart-table-column price-product res-15" data-title="UNIT PRICE">{{ item.discountedPriceUsd ? "$" + item.discountedPriceUsd : (item.discountedPrice ? "R" + item.discountedPrice : "") }}</td>
                                    <td class="cart-table-column edit-product res-15 p-3" data-title="EDIT">
                                        <button class="contact-btn btn-site-primary" v-on:click="remove(item)">Remove</button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot class="cart-table-foot">
                                <tr>
                                    <td colspan="4"></td>
                                    <td class="flat-button">
                                        <div class="d-flex justify-content-center">
                                            <router-link to="/courses" class="btn btn-site-primary">CONTINUE SHOPPING</router-link>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                        </div>
                        <div class="cart-mobile-list d-sm-none">
                            <div class="cart-mobile-item" v-for="item in cart">
                                <img v-bind:src="item | s3url" class="cart-mobile-img">
                                <div class="cart-mobile-details">
                                    <div class="cart-mobile-name">
                                        {{ item.name }}
                                        <span class="text-success" v-if="item.couponCode"> (Coupon: {{ item.couponCode }}, Discount: {{ item.discountPercentage }}%)</span>
                                    </div>
                                    <div class="cart-mobile-price" v-if="!item.couponCode">{{ item.priceUsd ? "$" + item.priceUsd : (item.price ? "R" + item.price : "") }}</div>
                                    <div class="cart-mobile-price" v-if="item.couponCode">{{ item.discountedPriceUsd ? "$" + item.discountedPriceUsd : (item.discountedPrice ? "R" + item.discountedPrice : "") }}</div>
                                    <button class="contact-btn btn-site-primary" v-on:click="remove(item)">Remove</button>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <router-link to="/courses" class="btn btn-site-primary">CONTINUE SHOPPING</router-link>
                            </div>
                        </div>
                    </div>
                    <div v-else style="text-align: center;">
                        <p class="text-empty-cart">No Items currently in your cart.</p>
                        <router-link to="/courses" class="btn-browse-courses btn-site-primary">BROWSE COURSES</router-link>
                    </div>
                    <p class="text-danger text-center" v-if="cartError">{{ cartError }}</p>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <form class="disconut-code">
                            <div class="title">Discount Code</div>
                            <p>Enter your coupon code if you have one.</p>
                            <input type="text" v-model="couponCode">
                            <p class="text-danger">{{ couponCodeError }}</p>
                            <div class="flat-button text-right">
                                <button type="button" v-on:click="applyCoupon" class="btn-apply hv-bounce-bl btn-site-primary">APPLY</button>
                            </div>
                        </form>
                    </div>

                    <div class="col-md-2">

                    </div>
                    <div class="col-md-6">
                        <div class="d-flex justify-content-center">

                            <div class="cart-total" v-if="cart && cart.length">
                                <div class="cart-total-wrap">
                                    <!-- <div v-if="grandTotalUsd > 0">
                                        <h2>Select your preferred currency</h2>
                                        <br />
                                        <img class="currency-image" v-if="currency == 'zar'" v-on:click="currency = 'usd'" src="/wwwroot/images/cart/usd_disabled.png" />
                                        <img class="currency-image" v-if="currency == 'zar'" v-on:click="currency = 'zar'" src="/wwwroot/images/cart/zar.png" />

                                        <img class="currency-image" v-if="currency == 'usd'" v-on:click="currency = 'usd'" src="/wwwroot/images/cart/usd.png" />
                                        <img class="currency-image" v-if="currency == 'usd'" v-on:click="currency = 'zar'" src="/wwwroot/images/cart/zar_disabled.png" />
                                    </div>-->
                                    <br />
                                    <p>
                                        <h2>Confirm payment terms</h2>
                                    </p>
                                </div>
                                <div class="cart-total-wrap" v-if="currency == 'zar'">
                                    <p>
                                        <span>Subtotal Excl. VAT</span>
                                        <span>R {{ subTotal }}</span>
                                    </p>
                                    <p>
                                        <span>VAT @ 15%</span>
                                        <span>R {{ vat }}</span>
                                    </p>
                                    <p>
                                        <span>Grand total Incl. VAT</span>
                                        <span>R {{ grandTotal }}</span>
                                    </p>
                                </div>
                                <div class="cart-total-wrap" v-if="currency == 'usd'">
                                    <p>
                                        <span>Subtotal Excl. VAT</span>
                                        <span>$ {{ grandTotalUsd }}</span>
                                    </p>
                                    <p>
                                        <span>VAT</span>
                                        <span>$ 0 (Exempt)</span>
                                    </p>
                                    <p>
                                        <span>Grand total</span>
                                        <span>$ {{ grandTotalUsd }}</span>
                                    </p>
                                    <br />
                                    <p class="text-warning">
                                        Note: USD payments are for international (Outside of South Africa) payments only and is except of Value Added Tax.
                                    </p>
                                </div>

                                <p>
                                    <a v-if="siteDesign.footer.termsFileName !== ''" :href="siteDesign.footer | s3url('terms')" class="footer-tx" target="_blank">Terms & conditions</a>
                                </p>
                                <br />
                                <div class="flat-button">
                                    <button type="button" v-on:click="pay" class="btn-proce-checkout hv-bounce-bl btn-site-primary">PROCEED TO CHECKOUT</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- shopping-cart -->
</template>

<style scoped>
    .text-empty-cart {
        font-size: 28px;
        color: black;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    .border-bt {
        bottom: 67px !important;
    }

    .add-cart {
        top: 44% !important;
    }

    .cart-mobile-item {
        display: flex;
        gap: 12px;
        padding: 15px 0;
        border-bottom: 1px solid #f3f6fb;
    }

    .cart-mobile-img {
        width: 90px;
        height: 90px;
        object-fit: contain;
        flex-shrink: 0;
    }

    .cart-mobile-details {
        flex: 1;
        min-width: 0;
    }

    .cart-mobile-name {
        font-size: 16px;
        color: #000000;
    }

    .cart-mobile-price {
        margin-top: 6px;
        font-weight: 600;
    }

    .cart-mobile-details button {
        margin-top: 10px;
    }

    .currency-image {
        cursor: pointer;
    }
    /* form-cart
            -------------------------------------------------------------- */
    .shopping-cart .form-cart {
        margin-bottom: 50px;
    }

    .form-cart .shop-table {
        width: 100%;
    }

        .form-cart .shop-table thead tr th {
            padding: 19px 0 15px 0;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            color: #000000;
        }

    .shop-table th, .shop-table td {
        border: 1px solid #f3f6fb;
    }

    .form-cart .shop-table .cart-table-body tr .describe-product .text {
        font-size: 16px;
        color: #000000;
    }

    .form-cart .shop-table .cart-table-body tr .describe-product p {
        font-size: 13px;
        margin-top: 6px;
    }

    .form-cart .shop-table .cart-table-body tr .edit-product i {
        width: 100%;
    }

    .form-cart .shop-table .cart-table-body tr .model-product {
        font-size: 13px;
    }

    .form-cart .shop-table .cart-table-body tr .res-15 {
        padding: 0 17px;
        text-align: center;
    }

    .form-cart .shop-table .cart-table-body tr .quantite-product .quantity {
        position: relative;
        width: 68px;
        height: 30px;
        margin: 0 auto;
    }

    .form-cart .shop-table .cart-table-body tr .quantite-product input {
        height: 30px;
        border: 2px solid #000;
        text-align: center;
        color: #b1b1b1;
    }

    .quantity input::-webkit-outer-spin-button,
    .quantity input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        -moz-appearance: textfield;
    }

    .form-cart .shop-table .cart-table-body tr .quantite-product a {
        position: absolute;
        top: 0;
        width: 15px;
        height: 30px;
        color: #fff;
        background: #000;
        padding-top: 2px;
        text-align: center;
    }

        .form-cart .shop-table .cart-table-body tr .quantite-product a.minus {
            left: 0;
            border-bottom-left-radius: 6px;
            border-top-left-radius: 6px;
        }

        .form-cart .shop-table .cart-table-body tr .quantite-product a.plus {
            right: 0;
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
        }

    .form-cart .shop-table .cart-table-foot tr .flat-button {
        padding: 15px 30px;
    }

        .form-cart .shop-table .cart-table-foot tr .flat-button button {
            font-size: 13px;
            font-weight: 700;
            padding: 8px 15px 9px 15px;
        }

        .form-cart .shop-table .cart-table-foot tr .flat-button .btn-continue {
            float: left;
            background-color: #3f4c99;
            border-color: #3f4c99;
        }

        .form-cart .shop-table .cart-table-foot tr .flat-button .btn-update-cart {
            float: right;
            border-radius: 23px;
            background-color: #3f4c99;
            border-color: #3f4c99;
        }

    .shopping-cart .three-column {
        margin-bottom: 102px;
    }

    .estimate-shipping,
    .disconut-code,
    .cart-total {
        border: 1px solid #f3f6fb;
        border-radius: 6px;
    }

        .estimate-shipping .title,
        .disconut-code .title {
            font-size: 16px;
            line-height: 20px;
            font-weight: 600;
            color: #000000;
            margin-bottom: 18px;
        }

        .estimate-shipping .flat-button,
        .disconut-code .flat-button {
            font-size: 13px;
            font-weight: 700;
            border-color: #3f4c99;
        }

    .estimate-shipping {
        padding: 24px 26px 29px 20px;
    }

        .estimate-shipping .text-info {
            margin-bottom: 20px;
        }

            .estimate-shipping .text-info .text {
                margin-bottom: 7px;
            }

                .estimate-shipping .text-info .text label {
                    font-size: 13px;
                    color: #000000;
                    margin-bottom: 4px;
                }

                .estimate-shipping .text-info .text input {
                    height: 36px;
                    background-color: #f3f3f3;
                    border-radius: 0;
                    padding: 0 9px;
                }

        .estimate-shipping .flat-button .btn-get-quote {
            padding: 8px 18px 8px 19px;
        }

    .disconut-code {
        padding: 24px 29px 30px 24px;
    }

        .disconut-code p {
            font-size: 13px;
            margin-bottom: 14px;
        }

        .disconut-code input {
            height: 32px;
            background-color: #f3f3f3;
            border-radius: 0;
            padding: 0 9px;
        }

        .disconut-code .flat-button {
            margin-top: 20px;
        }

            .disconut-code .flat-button .btn-apply {
                padding: 5px 29px 4px 24px;
            }

    .cart-total {
        padding: 23px 22px 20px 20px;
        text-align: right;
    }

        .cart-total .cart-total-wrap {
            margin-bottom: 25px;
        }

            .cart-total .cart-total-wrap p span {
                font-size: 16px;
                font-weight: 600;
                color: #000000;
            }

    .cart-total-wrap span {
        text-align: right;
    }

    .cart-total .cart-total-wrap p span:nth-of-type(2) {
        margin-left: 23px;
    }

    .cart-total .flat-button .btn-proce-checkout {
        padding: 20px 40px 18px 48px;
        font-size: 16px;
        font-weight: 700;
        border-radius: 40px;
        border-color: #3f4c99;
        color: white;
        box-shadow: 0 8px 6px -6px black;
    }
</style>

<script>

    export default {
        name: 'Cart',
        data: function () {
            return {
                currency: 'zar',
                couponCode: '',
                couponCodeError: '',
                cartError: ''
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart;
            },
            subTotal() {
                var total = this.cart.reduce((sum, item) => {

                    if (item.discountedPrice == null || item.discountedPrice == undefined)
                        return sum + item.price;
                    else
                        return sum + item.discountedPrice;

                }, 0);
                return total;
            },
            vat() {
                return this.subTotal * 15.0 / 100.0
            },
            grandTotal() {
                return this.subTotal + this.vat;
            },
            isAuthenticated() {
                return this.$store.state.isAuthenticated;
            },
            grandTotalUsd() {
                var total = this.cart.reduce((sum, item) => {

                    if (item.discountedPriceUsd == null || item.discountedPriceUsd == undefined)
                        return sum + item.priceUsd;
                    else
                        return sum + item.discountedPriceUsd;

                }, 0);
                return total;
            },
            siteDesign() {
                return this.$store.state.siteDesign;
            }
        },
        methods: {
            async pay() {

                if (this.isAuthenticated) {

                    this.cartError = '';

                    var response;
                    try {
                        response = await this.web('/cart/Prepare', "Contacting payment provider", {
                            cart: this.cart,
                            currency: this.currency
                        }, [409]);
                    }
                    catch (e) {
                        if (e && e.response && e.response.status == 409) {
                            var ownedCourses = e.response.data.courses || [];
                            var ownedPackages = e.response.data.packages || [];

                            var messages = [];
                            ownedCourses.forEach(course => messages.push(`"${course.name}" removed - you already own this course.`));
                            ownedPackages.forEach(pkg => messages.push(`"${pkg.name}" package removed - you already own ${pkg.ownedCourseNames.join(" and ")}.`));

                            var ownedCourseIds = ownedCourses.map(x => x.id);
                            var ownedPackageIds = ownedPackages.map(x => x.id);

                            this.cart
                                .filter(item => (item.type == "course" && ownedCourseIds.indexOf(item.id) > -1) || (item.type == "package" && ownedPackageIds.indexOf(item.id) > -1))
                                .forEach(item => this.$store.commit("removeFromCart", item));

                            this.cartError = messages.join(" ");
                            return;
                        }
                        throw e;
                    }

                    if (response.properties) {
                        setTimeout(function () {
                            var newForm = $('<form>', { 'action': response.action, 'method': "post" });
                            for (var name in response.properties) {
                                newForm.append($('<input>', { 'name': name.toUpperCase(), 'value': response.properties[name], 'type': 'hidden' }));
                            }

                            newForm.hide().appendTo("body").submit();
                        }, 100);
                    }
                    else {
                        this.$router.push(response.action);
                    }
                }
                else {
                    this.$router.push("/auth/login");
                }
            },
            remove(course) {
                this.$store.commit("removeFromCart", course);
            },
            async applyCoupon() {

                this.couponCodeError = "";

                if (this.couponCode == null || this.couponCode.length < 6) {
                    this.couponCodeError = "Invalid coupon code";
                    return;
                }

                try {
                    var couponInfo = await this.web("/coupons/" + this.couponCode, "Checking your coupon code", null, [404]); 
                    if (couponInfo.behaviour == "all") {
                        console.log(couponInfo); 
                        for (var i = 0; i < couponInfo.courseIds.length; i++) {

                            //check if course exists in cart 
                            var courseCartItem = this.cart.find(x => x.type == "course" && x.id == couponInfo.courseIds[i]);

                            if (courseCartItem == null) {
                                var course = await this.web("/courses/info/" + couponInfo.courseIds[i], "Adding your course");

                                this.$store.commit("addToCart", {
                                    type: "course",
                                    id: course.id,
                                    name: course.name,
                                    price: course.price,
                                    priceUsd: course.priceUsd,
                                    imageFileName: course.imageFileName
                                });

                                courseCartItem = this.cart.find(x => x.type == "course" && x.id == couponInfo.courseIds[i]);
                                courseCartItem.couponCode = couponInfo.code;
                                courseCartItem.discountPercentage = couponInfo.discountPercentage;
                                courseCartItem.discountedPrice = courseCartItem.price - couponInfo.discountPercentage * courseCartItem.price / 100.0;
                                courseCartItem.discountedPriceUsd = courseCartItem.priceUsd - couponInfo.discountPercentage * courseCartItem.priceUsd / 100.0;
                            }
                        }
                    }
                    else {
                        //check if course exists in cart
                        var courseCartItem = this.cart.find(x => x.type == "course" && couponInfo.courseIds.indexOf(x.id) > -1);

                        if (courseCartItem == null) {

                            if (couponInfo.courseIds.length == 1) {
                                //add course to cart
                                var course = await this.web("/courses/info/" + couponInfo.courseIds[0], "Adding your course");

                                this.$store.commit("addToCart", {
                                    type: "course",
                                    id: course.id,
                                    name: course.name,
                                    price: course.price,
                                    priceUsd: course.priceUsd,
                                    imageFileName: course.imageFileName
                                });

                                courseCartItem = this.cart.find(x => x.type == "course" && couponInfo.courseIds.indexOf(x.id) > -1);
                                courseCartItem.couponCode = couponInfo.code;
                                courseCartItem.discountPercentage = couponInfo.discountPercentage;
                                courseCartItem.discountedPrice = courseCartItem.price - couponInfo.discountPercentage * courseCartItem.price / 100.0;
                                courseCartItem.discountedPriceUsd = courseCartItem.priceUsd - couponInfo.discountPercentage * courseCartItem.priceUsd / 100.0;
                            }
                            else {
                                this.couponCodeError = "This coupon code applies to multiple products. Please add an item to the cart first.";
                                return;
                            }
                        }
                    }
                }
                catch (e) {
                    console.error(e);
                    this.couponCodeError = "Invalid coupon code. The code either does not exist or has already been redeemed";
                }
            }
        },
        mounted: function () {
            var crumbs = {};
            crumbs["/cart"] = "Cart";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>